// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { color, xScreen } from "@awc/XDL/Utilities";
import { languageMenuStyles } from "@insite/content-library/Widgets/Common/LanguageMenu";
import { IconWrapper } from "@insite/mobius/Icon";
import Globe from "@insite/mobius/Icons/Globe";
import { css } from "styled-components";

languageMenuStyles.languageWrapper = {
    css: css`
        display: flex;
        align-items: center;
    `,
};

languageMenuStyles.languageSelect = {
    cssOverrides: {
        formInputWrapper: css`
            min-width: 133px;
        `,
        inputSelect: css`
            height: 32px;
            ${IconWrapper} {
                height: 28px;
            }
        `,
    },
    css: css`
        margin-left: 8px;
    `,
};

languageMenuStyles.languageIcon = {
    src: Globe,
    size: 14,
    color: "primary.main",
    css: css`
        &,
        svg {
            width: 12px;
        }
        ${xScreen("lte", "sm")} {
            &,
            svg {
                width: 17px;
                height: 20px;
            }
        }
    `,
};
